export default [
  {
    title: 'Dashboard',
    to: { name: 'index' },
    icon: { icon: 'mdi mdi-view-dashboard' },
  },
  {
    title: 'New Order',
    to: { name: 'new-order' },
    icon: { icon: 'mdi mdi-plus-circle' },
    badgeContent: 'New',
    badgeClass: 'bg-success',
  },
  {
    title: 'Orders',
    to: { name: 'orders' },
    icon: { icon: 'mdi mdi-receipt-text' },
  },
  {
    heading: 'Management',
  },
  {
    title: 'Tables',
    to: { name: 'tables' },
    icon: { icon: 'mdi mdi-table-furniture' },
  },
  {
    title: 'Bookings',
    to: { name: 'reservations' },
    icon: { icon: 'mdi mdi-calendar-clock' },
  },
  {
    title: 'Reports',
    to: { name: 'reports' },
    icon: { icon: 'mdi mdi-chart-box' },
  },
  {
    heading: 'System',
  },
  {
    title: 'Staff',
    to: { name: 'staff' },
    icon: { icon: 'mdi mdi-account-multiple' },
  },
  {
    title: 'Printers',
    to: { name: 'printer' },
    icon: { icon: 'mdi mdi-printer' },
  },
  {
    title: 'Settings',
    to: { name: 'settings' },
    icon: { icon: 'mdi mdi-cog' },
  },
]
